module.exports = __webpack_public_path__ + "img/licensePlate.68109f4e.svg";